import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { LogoPropsType } from '../Logos/logoTypes';
import Link from 'next/link';
import { ComponentType } from 'react';
import Button from '../Button';

export interface CustomerCardProps {
  icon: ComponentType<LogoPropsType>;
  text: string;
  targetText: string;
  target: string;
}

const CustomerCard: React.FC<CustomerCardProps> = ({ icon: Logo, text, targetText, target }) => {
  const cardContent = (
    <>
      <div className="h-28 rounded-t-2xl bg-light-background-100 py-10 shadow-custom-sm">
        <Logo className="m-auto max-h-12 max-w-[14rem] text-gray-3" monochrome />
      </div>
      <div className="text-body card-body rounded-b-2xl bg-white px-4 py-6 text-gray-2 shadow-custom-sm">
        <p className="line-clamp-4">{text}</p>
        <div className="flex w-full items-center justify-between text-black transition-all duration-300 group-hover:text-gradle-blue ">
          <span>{targetText}</span>
          <Button
            outline
            variant="ghost-light"
            size="sm"
            className="self-end from-primary to-secondary outline outline-1 outline-gray-5 transition-[background-image_translate] duration-300 group-hover:-translate-y-0.5 group-hover:bg-gradient-to-br group-hover:outline-none"
            roundedFull
            onClick={() => {}}
          >
            <ArrowRightIcon className="size-4 text-black group-hover:text-white md:size-5" />
          </Button>
        </div>
      </div>
    </>
  );

  return target.includes('http') ? (
    <a href={target} target="_blank" rel="noopener" className="group card size-80">
      {cardContent}
    </a>
  ) : (
    <Link href={target} className="group card size-80">
      {cardContent}
    </Link>
  );
};

export default CustomerCard;
